import React, { useState, useRef } from "react";
import video_icon from "../../assets/images/webp/video_icon.jpg";
import video_icon1 from "../../assets/images/webp/video_icon1.jpg";
import chulla_nondh from "../../assets/images/webp/chulla_nondh.jpg";

// News Images Imported
import image_onee from "../../assets/images/news/news_one.png";
import image_twoo from "../../assets/images/news/news_2.png";
import image_three from "../../assets/images/news/news_3.png";
import img8 from "../../assets/images/news/abhimanyu.jpg";
import img7 from "../../assets/images/news/akhilender.jpg";
import image_two from "../../assets/images/png/cm-yuva-yojna3.png";

// Top 6 Latest News Array
const topNews = [
  {
    image: image_onee,
    title: "Haryana AVGC-XR Policy 2026: HKI Media Announces ₹10 Crore Centre of Excellence",
    desc: "As Haryana launches its AVGC-XR Policy 2026 under Make in Haryana vision, Gurgaon-based HKI Media steps up as an early mover with a ₹10 crore Centre of Excellence for animation, gaming, and immersive tech.",
    link: "https://aninews.in/news/business/haryana-bets-big-on-animation-and-gaming-as-a-gurgaon-startup-seeks-a-place-in-the-growth-story20260606121059/",
  },
  {
    image: image_twoo,
    title: "HKI Media to Build AVGC-XR Centre of Excellence in Haryana with R&D and Startup Incubation",
    desc: "HKI Media's planned AVGC-XR Centre of Excellence in Haryana will integrate R&D, IP creation labs, startup incubation, and VFX production infrastructure to build a future-ready creative technology ecosystem.",
    link: "https://theprint.in/ani-press-releases/haryana-bets-big-on-animation-and-gaming-as-a-gurgaon-startup-seeks-a-place-in-the-growth-story/2952503/",
  },
  {
    image: image_three,
    title: "HKI Media's ICASA to Bridge the Animation and Gaming Skills Gap Across India",
    desc: "Through ICASA's Learn • Create • Work & Earn model, HKI Media aims to close India's animation and gaming skills gap moving learners directly from training into employment.",
    link: "https://www.latestly.com/agency-news/business-news-haryana-bets-big-on-animation-and-gaming-as-a-gurgaon-startup-seeks-a-place-in-the-growth-story-7461475.html",
  },
  {
    image: img8,
    title: "HKI Media Partners with National Skill Development Corporation",
    desc: "HKI Media has officially partnered with the National Skill Development Corporation and Startup Stairs, reinforcing its position as a driving force in shaping the future of India’s creative economy.",
    link: "https://businessnewsthisweek.com/business/hki-media-partners-with-national-skill-development-corporation-and-startup-stairs-to-drive-national-entrepreneurship-in-indias-creative-economy/",
  },
  {
    image: img7,
    title: "HKI Media has launched the upgraded Gig Media app",
    desc: "A Media-tech platform designed to connect artists, performers and creative professionals with opportunities across India’s media and entertainment sector.",
    link: "https://sunitinews.blogspot.com/2026/03/hki-media-unveils-its-media-tech.html",
  },
  {
    image: image_two,
    title: "HKI Media Partners CM Yuva Mission to Launch 500 AVGC-XR Studios",
    desc: "In a significant move to boost India’s creative economy, HKI Media has partnered with the Chief Minister Yuva Udyami Yojana to set up 500 AVGC-XR media studios across Uttar Pradesh.",
    link: "https://aninews.in/news/business/hki-media-joins-hands-with-cm-yuva-yojana-to-launch-500-avgc-xr-studios-across-uttar-pradesh20251222132855/",
  },
];

// Premium Video Card Component with Hover-Play Logic
const VideoCard = ({ videoKey, thumbnail, src, isYoutube, playingVideo, playVideo }) => {
  const isPlaying = playingVideo === videoKey;
  const [isHovered, setIsHovered] = useState(false);
  const hoverVideoRef = useRef(null);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (hoverVideoRef.current && !isPlaying) {
      // Autoplay preview on hover (must be muted)
      hoverVideoRef.current.play().catch(() => {});
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (hoverVideoRef.current && !isPlaying) {
      hoverVideoRef.current.pause();
      hoverVideoRef.current.currentTime = 0;
    }
  };

  return (
    <div className="col-lg-6 col-md-6 mt-4">
      <div
        className={`premium-media-card ${isPlaying ? "is-playing" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => !isPlaying && playVideo(videoKey)}
      >
        {isPlaying ? (
          isYoutube ? (
            <iframe
              className="w-100 h-100"
              style={{ border: "none" }}
              src={`${src}?autoplay=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <video
              className="w-100 h-100 object-fit-cover"
              src={src}
              controls
              autoPlay
              playsInline
            />
          )
        ) : (
          <>
            <img
              src={thumbnail}
              alt="thumbnail"
              className="premium-media-thumb"
              loading="lazy"
              decoding="async"
            />
            <div className="premium-media-scrim" />
            <div className="premium-video-overlay">
              <span className="premium-play-icon">
                <svg viewBox="0 0 24 24" width="22" height="22">
                  <path d="M8 5.14v13.72c0 .74.81 1.19 1.44.81l10.87-6.86a.95.95 0 0 0 0-1.62L9.44 4.33C8.81 3.95 8 4.4 8 5.14Z" fill="currentColor" />
                </svg>
              </span>
            </div>
            {/* Background Hover Preview Video for MP4s */}
            {!isYoutube && (
              <video
                ref={hoverVideoRef}
                className="hover-video-preview"
                src={src}
                muted
                loop
                playsInline
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

// Premium News Card Component
const NewsCard = ({ item }) => {
  return (
    <div className="col-lg-4 col-md-6 mt-4 d-flex">
      <a href={item.link} target="_blank" rel="noopener noreferrer" className="premium-news-card">
        <div className="premium-news-img-wrap">
          <img
            src={item.image}
            alt={item.title}
            className="premium-news-img"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="premium-news-content">
          <h4 className="premium-news-title">{item.title}</h4>
          <p className="premium-news-desc">{item.desc}</p>
          <span className="premium-news-readmore">
            Read Article
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </span>
        </div>
      </a>
    </div>
  );
};

// Main Section Component
const MediaNews = () => {
  const [playingVideo, setPlayingVideo] = useState(null);

  // S3 & Youtube URLs
  const VIDEO_1_URL = "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hero/news_video1.1e8dfa1a7e085e50415c.mp4";
  const VIDEO_2_URL = "https://hki-web-public-assets.s3.ap-south-1.amazonaws.com/hero/news_video2.d26598fbd9ec8a6bdbdd.mp4";
 

  const playVideo = (videoKey) => {
    setPlayingVideo(videoKey);
  };

  return (
    <div className="home-section-pad section-cream-alt position-relative overflow-hidden">
      <div className="container position-relative z-1">
        <div className="text-center mb-5">
          <h3 className="section-heading">
            Media & <span className="section-heading-accent">News</span>
          </h3>
          <p className="section-subtitle">
            Catch our latest coverage, appearances, and stories in the spotlight.
          </p>
        </div>

        <div className="row mb-5 pb-3">
          <VideoCard videoKey="video1" thumbnail={video_icon} src={VIDEO_1_URL} isYoutube={false} playingVideo={playingVideo} playVideo={playVideo} />
          <VideoCard videoKey="video2" thumbnail={video_icon1} src={VIDEO_2_URL} isYoutube={false} playingVideo={playingVideo} playVideo={playVideo} />
        </div>

        <div className="row g-4">
          {topNews.map((item, idx) => (
            <NewsCard key={idx} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MediaNews;
